/* eslint-disable camelcase */
import _ from 'lodash'

import * as graph from '@shared/types/graphql'

export type Mode = 'organization' | 'workspace'

export interface OrgViewOption {
  isOrg: boolean,
  name: string,
  id?: string
}

export type ViewOption = OrgViewOption | Partial<graph.Workspace>

export interface ListLocation {
  index: number
  test: graph.ActiveTest
}

export function workspaceForTest (test: graph.ActiveTest, workspaces: ViewOption[]): ViewOption | undefined {
  return workspaces.find(ws => ws.id === test.workspaceId)
}

export function experimentsForTest (test: graph.ActiveTest, workspaces: ViewOption[]) {
  const workspace = workspaceForTest(test, workspaces)
  if (!workspace) {
    return false
  }
  const experiments = workspaceExperiments(workspace)
  return experiments.filter(report => {
    if (!report.ids) return false
    return report.ids.includes(test.id.toString())
  })
}

export function workspaceExperiments (workspace: ViewOption) {
  const reports = _.get(workspace, 'payload.reports', {})
  return Object.keys(reports)
    .map(reportId => {
      return {
        id: reportId,
        ...reports[reportId]
      }
    })
}
